export default {"src":"/_next/static/media/bcn.bbda5c9c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};